import React, {useState, useEffect} from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import {
    FlexibleXYPlot,
    XAxis,
    YAxis,
    LineSeries,
    AreaSeries,
    GradientDefs,
    Crosshair,
    VerticalBarSeries
} from "react-vis";

import DateRangePicker from "../../components/DateRangePicker";

import "../../../node_modules/react-vis/dist/style.css";

import api from "../../service/api";

import "react-dates/initialize";
import "../../../node_modules/react-vis/dist/style.css";
import iconGear from "../../assets/icons/gearWhite.svg"

import { 
    Container, 
    GraficHeader, 
    FilterLabel, 
    PeriodButton, 
    PeriodButtonText, 
    DateContainer, 
    FilterDateAndButtonsContainer, 
    FilterDateConteiner, 
    PeriodButtonsContainer,
    IconGraphicChange,
    ButtonChangeTypeGraphic
} from "./styles";

import {
    Menu,
    MenuItem,
    MenuButton,
    SubMenu
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

const Graphic = (props) => {
    const [filterGraficButton, setFilterGraficButton] = useState(1);
    const [graphicData, setGraphicData] = useState([
        {x: 0, y: 0},
        {x: 1, y: 0},
        {x: 2, y: 0},
        {x: 3, y: 0},
        {x: 4, y: 0},
        {x: 5, y: 0},
        {x: 6, y: 0},
        {x: 7, y: 0},
        {x: 8, y: 0},
        {x: 9, y: 0},
        {x: 10, y: 0},
        {x: 11, y: 0},
    ]);
    const [graphicDataRaw, setGraphicDataRaw] = useState([])
    const [xPositions, setXPositions] = useState([]);
    const [maxYNumber, setMaxYNumber] = useState(1);
    const [crosshairValues, setCrosshairValues] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const monthsInter = {1:"Janeiro", 2: "Fevereiro", 3: "Março", 4: "Abril", 5: "Maio", 6: "Junho",
    7: "Julho", 8: "Agosto", 9: "Setembro", 10: "Outubro", 11: "Novembro", 12: "Dezembro"}

    const months = {
        1 : "JAN",
        2 : "FEV",
        3 : "MAR",
        4 : "ABR",
        5 : "MAI",
        6 : "JUN", 
        7 : "JUL", 
        8 : "AGO",
        9 : "SET", 
        10 : "OUT", 
        11 : "NOV", 
        12 : "DEZ"};

    useEffect(() => {
        const getPeriodGraphicData = async () => {
            if(startDate !== null && endDate !== null){
                if(props.isOwner === true){
                    const { data } = await api.get("/dashboard/owner", {
                        params: {
                            id: props.sellerOwnerPayId,  //login.user.branchs.sellerOwnerPayId
                            startdate: moment(startDate).format("YYYY-MM-DD"),
                            stopdate: moment(endDate).format("YYYY-MM-DD")
                        }
                    });
                    
                    setGraphicDataRaw(data.Graph);
                    
                    const xAndYPositions = data.Graph.map((position, index) => {
                        
                        return {
                            x: index,
                            y: `${position.Soma === null ? 0 : position.Soma}`
                        }
                    });
                    
                    setGraphicData(xAndYPositions);
                } else {
                    const { data } = await api.get("/dashboard", {
                        params: {
                            id: props.sellerOwnerPayId,  //login.user.branchs.sellerOwnerPayId
                            startdate: moment(startDate).format("YYYY-MM-DD"),
                            stopdate: moment(endDate).format("YYYY-MM-DD")
                        }
                    });
                    
                    setGraphicDataRaw(data.Graph);
                    
                    const xAndYPositions = data.Graph.map((position, index) => {
                        
                        return {
                            x: index,
                            y: `${position.Soma === null ? 0 : position.Soma}`
                        }
                    });
                    
                    setGraphicData(xAndYPositions);

                }
            }
        }

        const getMonthGraphicData = async () => {
            if(props.isOwner === true) {
                const date = new Date();
                const month = date.getMonth() + 1;
                const { data } = await api.get("/dashboard/owner", {
                    params: {
                        id: props.sellerOwnerPayId,
                        month
                    }
                });
                
                setGraphicDataRaw(data.Graph);
                
                const xAndYPositions = data.Graph.map((position) => {
                    const month = position["mes"];
                    
                    return {
                        x: parseInt(month),
                        y: `${position.sum === null ? 0 : position.sum}`
                    }
                });
                
                setGraphicData(xAndYPositions);
            } else {
                const date = new Date();
                const month = date.getMonth() + 1;
                const { data } = await api.get("/dashboard", {
                    params: {
                        id: props.sellerOwnerPayId,
                        month
                    }
                });
                
                setGraphicDataRaw(data.Graph);
                
                const xAndYPositions = data.Graph.map((position) => {
                    const month = position["mes"];
                    
                    return {
                        x: parseInt(month),
                        y: `${position.sum === null ? 0 : position.sum}`
                    }
                });
                
                setGraphicData(xAndYPositions);
            }
        }

        const getWeekGraphicData = async () => {    
            if(props.isOwner === true){
                const { data } = await api.get("/dashboard/owner", {
                    params: {
                        id: props.sellerOwnerPayId,
                        week: true
                    }
                });
                
                setGraphicDataRaw(data.Graph);
                
                const xAndYPositions = data.Graph.map((position, index) => {
                    // const month = position.Data.split("-");
                    return {
                        x: index,
                        y: `${position.Soma === null ? 0 : position.Soma}`
                    }
                });
                
                setGraphicData(xAndYPositions);
            } else {
                const { data } = await api.get("/dashboard", {
                    params: {
                        id: props.sellerOwnerPayId,
                        week: true
                    }
                });
                
                setGraphicDataRaw(data.Graph);
                
                const xAndYPositions = data.Graph.map((position, index) => {
                    
                    return {
                        x: index,
                        y: `${position.Soma === null ? 0 : position.Soma}`
                    }
                });
                
                setGraphicData(xAndYPositions);
            }     
        }
        
        
        if(props.sellerOwnerPayId !== null){
            switch (filterGraficButton){
                case 0: 
                    getPeriodGraphicData();
                    
                    return;
                
                case 1:
                    getMonthGraphicData();
                    
                    return;
                
                case 2:
                    getWeekGraphicData();
                    
                    return;
            }
        }
    }, [filterGraficButton, startDate, endDate, props.sellerOwnerPayId]);

    useEffect(() => {
        const newXPositions = graphicData.map(data => {
            return data.x
        });
        
        setXPositions(newXPositions);

        const newYPositions = graphicData.map(data => {
            return data.y
        });

        const maxY = Math.max(...newYPositions);
        
        setMaxYNumber(Math.round(maxY));
    }, [graphicData]);
    
    
    

      /**
     * Event handler for onMouseLeave.
     * @private
     */
    const _onMouseLeave = () => {
        setCrosshairValues([]);
    };

    /**
     * Event handler for onNearestX.
     * @param {Object} value Selected value.
     * @param {index} index Index of the value in the data array.
     * @private
     */
    const _onNearestX = (value, {index}) => {
        let newCrosshairVaules = [];
        
        newCrosshairVaules.push(graphicData[index]);
        setCrosshairValues(newCrosshairVaules);
    };
    
    return(
        <Container>
            <GraficHeader>
                <FilterDateAndButtonsContainer>
                    <FilterDateConteiner>
                        <FilterLabel>Filtrar por:</FilterLabel>
                        <DateContainer>
                            {/* <img src={calendarGreenIcon} style={{marginLeft: 10, marginRight: 9}}/> */}
                            <DateRangePicker 
                                isDisabled={filterGraficButton === 0}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                        </DateContainer>
                    </FilterDateConteiner>
                    <PeriodButtonsContainer>
                        <PeriodButton isActive={filterGraficButton === 0} onClick={() => setFilterGraficButton(0)}><PeriodButtonText>Período</PeriodButtonText></PeriodButton>
                        <PeriodButton isActive={filterGraficButton === 2} onClick={() => setFilterGraficButton(2)}><PeriodButtonText>Semana</PeriodButtonText></PeriodButton>
                        <PeriodButton isActive={filterGraficButton === 1} onClick={() => setFilterGraficButton(1)}><PeriodButtonText>Mês</PeriodButtonText></PeriodButton>

                        <PeriodButton isActive={true} style={{width: 30}} className="align-items-center justify-content-center" >
                            <Menu menuButton={<MenuButton>{<IconGraphicChange  src={iconGear}/>}</MenuButton>} transition>
                                <SubMenu label="Gráfico">
                                    <MenuItem onClick={() => props.setType("bar")}>Barra</MenuItem>
                                    <MenuItem onClick={() => props.setType("line")}>Linha</MenuItem>
                                </SubMenu>
                            </Menu>
                        </PeriodButton>

                    </PeriodButtonsContainer>
                </FilterDateAndButtonsContainer>
            </GraficHeader>
            <FlexibleXYPlot
                onMouseLeave={_onMouseLeave}
                height={300} 
                margin={{left: 50}} 
                yDomain={[0, maxYNumber]}
            >
                <GradientDefs>
                    <linearGradient id="graficGradient" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor="#FCCA96" stopOpacity={0.4} />
                        <stop offset="100%" stopColor="#FEF9F2" stopOpacity={0.3} />
                    </linearGradient>
                </GradientDefs>
                <YAxis
                    title="R$"
                    style={{fontSize: 10, fill: "#B8B4CC", paddingLeft: 5}}
                    />
                <XAxis
                    style={{fontSize: 10, fill: "#B8B4CC"}}
                    tickValues={xPositions}
                    tickFormat={v => {
                        if(filterGraficButton === 0 && startDate !== null && endDate !== null){
                            const daysToSubtract = graphicDataRaw.length - (v + 1); // o número 1 foi necessário para corrigir o intervalo
                            
                            const intervalDays = () => {
                                const days = moment(endDate).subtract(daysToSubtract, "days").format("DD")
                                
                                for(let count = 1; count <= graphicDataRaw.length; count++){
                                    return days >= 1 && days <= 4 || days >= 6 && days <= 9 ||
                                        days >= 11 && days <= 14 || days >= 16 && days <= 19 || days >= 21 && days <= 24 ||
                                        days >= 26 && days <= 29 ||days == 31
                                    ? 
                                    "" : days
                                }
                            }
                            
                            const day = graphicDataRaw.length > 20 ? 
                                    graphicDataRaw.length > 32 ?     
                                        intervalDays() : moment(endDate).subtract(daysToSubtract, "days").format("DD")
                                    : moment(endDate).subtract(daysToSubtract, "days").format("DD/MM")

                            return day;
                        }
                        
                        if(filterGraficButton === 2){
                            const daysToSubtract = 7 - v;
                            const day = moment().subtract(daysToSubtract, "days").format("DD/MM");
                            
                            return day;
                        }

                        return filterGraficButton === 0 ? "" : months[v];
                    }}
                />

                {props.type === "line" 
                    ? <AreaSeries
                        color={"url(#graficGradient)"}
                        data={graphicData}
                    />
                    : null
                }

                { props.type === "line" 
                    ? <LineSeries
                        onNearestX={_onNearestX}
                        className="first-series"
                        data={graphicData}
                        style={{
                            strokeLinejoin: "round",
                            strokeWidth: 4 }}
                        color="#F58B1E" /> 
                    :  <VerticalBarSeries
                        onNearestX={_onNearestX}
                        className="first-series"
                        data={graphicData}
                        color="#F58B1E"
                        barWidth={.5}/> 
                }
                {
                    graphicDataRaw.length > 0 ? 
                    <Crosshair
                        values={crosshairValues}
                        titleFormat={(d) => null}
                        itemsFormat={(d) => {
                            if(filterGraficButton === 0) {
                                if(startDate !== null && endDate !== null){
                                    let date = graphicDataRaw[d[0].x - graphicData[0].x]?.Data?.split("-");
                                    
                                    date = date?.hasOwnProperty("Data") !== undefined
                                        ? `${date[2].padStart(2, "0").substr(0,2)}/${date[1]}/${date[0]}`
                                        : null
                                    
                                        return [{title: "Data", value: date}, {title: "Soma das transações", value: `R$ ${parseFloat(d[0].y).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}` }]
                                }
                                
                                const date = moment(graphicDataRaw[d[0].x]).add(3, "hours").format("DD/MM/YYYY");
                                
                                return [{title: "Data", value: date}, {title: "Soma das transações", value: `R$ ${parseFloat(d[0].y).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}` }]
                            } else if(filterGraficButton === 1) {
                                let selectedDate = d[0];
                                const sum = `${selectedDate?.y ?? null}`
                                const date = `${selectedDate?.x ?? null}`;
                                
                                return [{title: "Data", value: monthsInter[parseInt(date)]}, {title: "Soma das transações", value: `R$ ${parseFloat(sum).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}` }]
                            } else {
                                let date = graphicDataRaw[d[0].x - graphicData[0].x]?.Data?.split("-");
                                
                                date = date?.hasOwnProperty("Data") !== undefined
                                    ? `${date[2].padStart(2, "0").substr(0,2)}/${date[1]}/${date[0]}`
                                    : null
                                
                                    return [{title: "Data", value: date}, {title: "Soma das transações", value: `R$ ${parseFloat(d[0].y).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}` }]
                            }
                        }}
                    /> : null
                }
            </FlexibleXYPlot>
            
        </Container>
    )
}

export default Graphic;